import React from 'react';
import { Helmet } from "react-helmet";


const HeadData = (
  <Helmet>
    <title>關於農業視覺化 | 農業視覺化</title>
    <meta name="description" content="關於農業視覺化，數據資訊來自於政府開放平台，查詢內容包含農作物月平均價格、農作物當日市場批發價格。" />
  </Helmet>
);


const aboutContent = {
  why: {
    title: '為什麼會有視覺化農業?', 
    content: <p>農產品價格會隨著產季、氣候以及其他因素而有所波動，當批發價格或市售價格出現波動，往往會出現與媒體報導有所差異的情況。若能利用簡單操作的互動式資訊圖表，清楚地回顧歷年來的價格及市場波動情形，對於將進行耕作的農夫或想了解市場價格的消費者而言，能提供實際層面的參考。視覺化農業誕生的初衷，是希望能用更有效率的方式查詢農作物的歷史價格，因此利用最新的網頁技術，開發可跨平台使用的網頁應用程式。</p>},
  how: {
    title: '數據資料從哪裡來？',
    content: <p>視覺化農業中的數據來源為<span>行政院農業委員會農糧署</span>所統計出的資料，本站作者由農產品產地價格查報系統獲得原始的政府開放數據，並開發出網頁型的互動式資料視覺化。目前視覺化呈現的資料為蔬菜類及水果類的月平均價格。更新日期與政府開放資料同步為每個月更新一次。</p>},
  author: {
    title: '誰是視覺化農業的製作者？',
    content: <p>本站作者是 <a href="https://profoundstars.com" target="_blank" rel="noopener noreferrer">Aurora Liu</a>，為網站設計及開發的自由工作者。資訊化農業是一項社會回饋的製作，期許能利用現有政府的開放資料，製作出能與使用者互動式的資訊圖，讓資訊更容易傳遞及被理解。也希望查詢的功能是能夠跨平台使用，讓手機、平板及電腦只要有瀏覽器便能開啟使用，故製作響應式的網頁應用程式。<br/>若使用上有任何意見提供，或是您覺哪個部分可以有更完備的資訊，歡迎您與開發者聯繫。 <a href="https://profoundstars.com/contact" target="_blank" rel="noopener noreferrer">[點我聯繫作者]</a></p>}
};


const About = () => {
  window.scrollTo(0, 0);  //** to load top of the page
  
  return (
    <div id="about">
      { HeadData }
      <div id="about-title">
        <h1>關於<br/>農業視覺化</h1>
      </div>

      <div id="questions">
        <div id="about-why" className="about-question-div">
          <h2 className="about-question-title">{aboutContent.why.title}</h2>
          {aboutContent.why.content}
        </div>

        <div id="about-how" className="about-question-div">
        <h2 className="about-question-title">{aboutContent.how.title}</h2>
          {aboutContent.how.content}
        </div>

        <div id="about-author" className="about-question-div">
          <h2 className="about-question-title">{aboutContent.author.title}</h2>
          {aboutContent.author.content}
        </div>
      </div>
    </div>
  );
};


export { About };


// WEBPACK FOOTER //
// ./src/components/pages/about.js